"use client";
import posthogClient from "posthog-js";
import { PostHogProvider } from "posthog-js/react";

export function PHProvider({ children }: { children: React.ReactNode }) {
  return <PostHogProvider client={posthogClient}>{children}</PostHogProvider>;
}
